var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import { styled, createGlobalStyle, ThemeProvider } from 'styled-components';
import { useGoogleAnalytics } from '@happynumbers/front-utils';
import { useFetch } from '@hn-front/utils';
import globalTheme from '../../../landing/components/core/themes/theme';
import PageHeader from './PageHeader';
import PrintablesFilters from './PrintablesFilters';
import Domain from './Domain';
import NoPrintablesBanner from './NoPrintablesBanner';
import { parsePrintables } from './parsePrintables';
import { gaTrackerIds } from '../../../pages/utils';
import { usePrintablesDictionaries } from './hooks/usePrintablesDictionaries';
import { Banner } from './Banner';
import { PrintableContext } from './PrintableContext';
var GlobalStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  html {\n    --webkit-text-size-adjust: none;\n    text-size-adjust: none;\n  }\n"], ["\n  html {\n    --webkit-text-size-adjust: none;\n    text-size-adjust: none;\n  }\n"])));
var Page = styled.div.withConfig({ displayName: "Page", componentId: "sc-1vn8l4f" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 992px;\n  padding-left: 8px;\n  color: ", ";\n"], ["\n  width: 992px;\n  padding-left: 8px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var ScPrintablesFilters = styled(PrintablesFilters).withConfig({ displayName: "ScPrintablesFilters", componentId: "sc-sb894m" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 32px;\n"], ["\n  margin-top: 32px;\n"])));
var Printables = function (_a) {
    var gradeId = _a.gradeId, groupId = _a.groupId;
    var _b = usePrintablesDictionaries(), skills = _b[0], standards = _b[1], domains = _b[2], grades = _b[3];
    var _c = useState(String(gradeId === -1 ? 0 : gradeId)), selectedGrade = _c[0], setSelectedGrade = _c[1];
    var _d = useState([]), currentGradeStandards = _d[0], setCurrentGradeStandards = _d[1];
    var _e = useState([]), currentGradeSkills = _e[0], setCurrentGradeSkills = _e[1];
    var _f = useState([]), selectedSkillsAndStandards = _f[0], setSelectedSkillsAndStandards = _f[1];
    var _g = useState([]), printables = _g[0], setPrintables = _g[1];
    var ga4 = useGoogleAnalytics(gaTrackerIds);
    var handleOnGradeChange = useCallback(function (value) {
        var _a;
        var curGradeShortName = (_a = grades.find(function (_a) {
            var id = _a.id;
            return id === Number(value);
        })) === null || _a === void 0 ? void 0 : _a.data.shortName;
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("click_sort_by_grade_" + curGradeShortName, {
            category: 'Printables',
        });
        setSelectedGrade(value);
        setSelectedSkillsAndStandards([]);
    }, [ga4, grades]);
    var handleOnSkillAndStandardSelect = useCallback(function (items) {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('change_sort_by_skill', {
            category: 'Printables',
        });
        setSelectedSkillsAndStandards(items);
    }, [ga4]);
    var handleOnPackTagClick = useCallback(function (data) {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher("click_sort_by_tag_" + data.type, {
            category: 'Printables',
        });
        if (data.type === 'skill') {
            var result = currentGradeSkills.filter(function (_a) {
                var id = _a.id;
                return id === data.skillId;
            });
            setSelectedSkillsAndStandards(result);
        }
        else if (data.type === 'standard') {
            var result = currentGradeStandards.filter(function (_a) {
                var id = _a.id;
                return id === data.standardId;
            });
            setSelectedSkillsAndStandards(result);
        }
    }, [currentGradeSkills, currentGradeStandards, ga4]);
    useEffect(function () {
        fetch("/api/printables?grade_value=" + selectedGrade + "&group_id=" + groupId)
            .then(function (response) { return response.json(); })
            .then(function (data) { return setPrintables(data); });
    }, [selectedGrade, groupId]);
    useEffect(function () {
        setCurrentGradeSkills(skills.filter(function (skill) { return String(skill.value.gradeId) === selectedGrade; }));
        setCurrentGradeStandards(standards.filter(function (standard) {
            return standard.value.gradeIds.includes(Number(selectedGrade));
        }));
    }, [skills, standards, selectedGrade]);
    useEffect(function () {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('open_printables_library', {
            category: 'Printables',
        });
    }, [ga4]);
    var lockResponse = useFetch("/api/printables/unlock?group_id=" + groupId).response;
    var parsedData = lockResponse
        ? parsePrintables({
            printables: printables,
            domains: domains,
            standards: standards,
            skills: skills,
            selectedSkillsAndStandards: selectedSkillsAndStandards,
            unlockWith: lockResponse.unlockWith,
        })
        : undefined;
    var skillAndStandardsItems = __spreadArray(__spreadArray([], currentGradeSkills, true), currentGradeStandards, true);
    var handleOnBannerClick = useCallback(function (reason) {
        if (['premium', 'premium_admin'].includes(reason))
            document.location.href = '/pricing';
        else if (reason === 'invite_colleagues')
            document.location.href = '/teachers/boarding';
    }, []);
    return (_jsx(PrintableContext.Provider, __assign({ value: { groupId: groupId } }, { children: _jsxs(ThemeProvider, __assign({ theme: globalTheme }, { children: [_jsx(GlobalStyle, {}, void 0), _jsxs(Page, { children: [_jsx(PageHeader, { lockReason: lockResponse === null || lockResponse === void 0 ? void 0 : lockResponse.unlockWith }, void 0), lockResponse && lockResponse.unlockWith !== 'unlocked' && (_jsx(Banner, { lockReason: lockResponse.unlockWith, onClick: handleOnBannerClick }, void 0)), _jsx(ScPrintablesFilters, { grades: grades, selectedGrade: selectedGrade, onGradeChange: handleOnGradeChange, skillAndStandardsItems: skillAndStandardsItems, selectedSkillsAndStandards: selectedSkillsAndStandards, onSkillAndStandardSelect: handleOnSkillAndStandardSelect }, void 0), parsedData && parsedData.length > 0 ? (parsedData.map(function (data) {
                            return (_jsx(Domain, { data: data, onPackTagClick: handleOnPackTagClick, lockReason: lockResponse === null || lockResponse === void 0 ? void 0 : lockResponse.unlockWith }, "" + selectedGrade + data.domain));
                        })) : (_jsx(NoPrintablesBanner, {}, void 0))] }, void 0)] }), void 0) }), void 0));
};
export default Printables;
var templateObject_1, templateObject_2, templateObject_3;
